export const isJSON = (str) => {
    if (!str) {
        return false;
    }
    if (/^\s*$/.test(str))
        return false;
    str = str.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@');
    str = str.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']');
    str = str.replace(/(?:^|:|,)(?:\s*\[)+/g, '');
    return /^[\],:{}\s]*$/.test(str);
};
const safeReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
        // handle error object
        if (value instanceof Error) {
            return `Error.message: ${value.message} \n  Error.stack: ${value.stack}`;
        }
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return `[Circular ${key || 'root'}]`;
            }
            seen.add(value);
        }
        if (typeof value === 'function') {
            return 'function';
        }
        if (typeof value === 'symbol') {
            return 'symbol';
        }
        if (typeof value === 'undefined') {
            return null;
        }
        return value;
    };
};
export const safeStringify = (obj) => {
    if (typeof obj === 'string') {
        return obj;
    }
    try {
        if (obj instanceof Error) {
            return (JSON.stringify(obj, safeReplacer()) || 'undefined').replace(/"/gim, ''); // delete all ", since error Obj will be stringified twice.
        }
        return JSON.stringify(obj, safeReplacer());
    }
    catch (e) {
        return '{"error":"error happen when airTracker stringify"}';
    }
};
